import { SecurityDepositAction } from '../actions/SecurityDepositAction';
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const initState = {
    requestBody: {
        sectionId: "SecurityDeposit",
        steps: [
            {
                sequence: "0",
                stepId: "SecurityDeposit",
                offerContainerId: "",
                options: [
                    {
                        name: "Security Deposit",
                        value: "true"
                    }
                ],
                fields: [
                    {
                        name: "Deposit Amount",
                        value: ""
                    },
                    {
                        name: "Deposit Amount Response",
                        value: ""
                    }
                ]
            }
        ]
    },
    fetchSecurityDepositResponse: {

    }
}

const SecurityDepositReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var SecurityDepositValue = {...state.requestBody.steps};
    
    switch (type) {
        case SecurityDepositAction.FETCH_SECURITY_DEPOSIT_SUCCESS:
            return { ...state, fetchSecurityDepositResponse: payload };

        case SecurityDepositAction.SECURITY_DEPOSIT_ACCEPTED:
            SecurityDepositValue[0].offerContainerId = payload.offerContainerId;
            SecurityDepositValue[0].fields[0].value = payload.securityDepositResponse.SecurityDepositAmount;
            SecurityDepositValue[0].fields[1].value = JSON.stringify(payload.securityDepositResponse);
            return state;

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, fetchSecurityDepositResponse: {} };

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'SecurityDeposit')
            });
            if(section.length > 0) {
                SecurityDepositValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                for (let i = 0; i < SecurityDepositValue[0].fields.length; i++) {
                    const UnpaidValueField = section[0].steps[0].fields.filter((field: any) => { return (field.name === SecurityDepositValue[0].fields[i].name) })[0];
                    SecurityDepositValue[0].fields[i].value = UnpaidValueField ? UnpaidValueField.value : "";
               }
            }
            return state;

        default:
            return state;
    }
}

export default SecurityDepositReducer;